import type { FaireProductEntity } from "../../entity_types/product";

export const p_6jz5vbcf3z: FaireProductEntity = {
  token: "p_6jz5vbcf3z",
  type: "product",
  name: "Southwestern Natives Tee",
  brandToken: "b_6i5zv0objg",
  brandName: "Bird Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/1938efbbefee3ea03a08edd67e9e3e9c4e1af5843407cee505852b52d1bc5d15.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b9c5d6b5e48f060b8af5925995614611dbc317fab37e14ae06fbbb7fe278485d.jpeg",
    "https://cdn.faire.com/fastly/9465b93e040d2f4d31d544d5aadd43544b3d3f8a771c3d62f8b65848a5895551.jpeg",
    "https://cdn.faire.com/fastly/08b3e1f980736a2ddf4304fb87edad4a98428e997db613e348b68c85b3439e23.jpeg",
    "https://cdn.faire.com/fastly/1c7acab2ba24f4f8e81024e5310ef15c515e9d92684f03fd26be336b2817315d.jpeg",
    "https://cdn.faire.com/fastly/f4c256a0b35851b1eaceb29261ae3555499c0d622de0ca5b9f40277e22d8352c.jpeg",
  ],
  priceDollars: 29,
  description:
    "This colorful tee brings the Southwest to life, featuring a roadrunner, Bullock's Oriole, cacti, and blooming wildflowers. This sharp, desert-inspired design will stand out anywhere.\n",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:25.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
